import { childPath, adultPath, elderPath } from "./illustrationPathStrings";
import colorFn from "./colorFn";

const fillGivenStatus = (status, immuno) => {
  if (status === "SUSCEPTIBLE") {
    return immuno ? colorFn("IMMUNO") : colorFn("SUSCEPTIBLE");
  }

  return colorFn(status);
};

const initializeSimulationState = graph => {
  const generateFreshPopulation = () => {
    const nodeStatusHash = {};
    graph.nodes.forEach(n => {
      nodeStatusHash[n.id] = {
        status: "SUSCEPTIBLE",
        infectionDate: null
      };
    });
    nodeStatusHash["a"].status = "INFECTED";
    return nodeStatusHash;
  };

  return {
    population: generateFreshPopulation(),
    history: [
      {
        SUSCEPTIBLE: graph.nodes.length - 1,
        RECOVERED: 0,
        INFECTED: 1
      }
    ]
  };
};

const simulator = (
  nodes,
  neighboursLookup,
  previousSimState,
  { infectionChance = 0.1, infectionLength = 21 }
) => {
  const { population, history } = previousSimState;

  const day = history.length;

  const tallies = {
    SUSCEPTIBLE: 0,
    INFECTED: 0,
    RECOVERED: 0
  };

  let newInfections = [];
  let newRecoverys = [];

  nodes.forEach(n => {
    if (population[n.id].status === "SUSCEPTIBLE") {
      const neighbours = neighboursLookup[n.id].neighbours;
      const infectedNeighbours = neighbours.filter(d => {
        return population[d.id].status === "INFECTED";
      });

      const totalInfectionChance = Math.pow(
        1 - infectionChance,
        infectedNeighbours.length
      );
      const infectionEvent = Math.random() > totalInfectionChance;

      if (infectionEvent) {
        newInfections.push(n.id);
        tallies["INFECTED"] = tallies["INFECTED"] ? tallies["INFECTED"] + 1 : 1;
      } else {
        tallies["SUSCEPTIBLE"] = tallies["SUSCEPTIBLE"]
          ? tallies["SUSCEPTIBLE"] + 1
          : 1;
      }
    }

    if (population[n.id].status === "INFECTED") {
      if (day - population[n.id].infectionDate > infectionLength) {
        newRecoverys.push(n.id);
        tallies["RECOVERED"] = tallies["RECOVERED"]
          ? tallies["RECOVERED"] + 1
          : 1;
      } else {
        tallies["INFECTED"] = tallies["INFECTED"] ? tallies["INFECTED"] + 1 : 1;
      }
    }

    if (population[n.id].status === "RECOVERED") {
      tallies["RECOVERED"] = tallies["RECOVERED"]
        ? tallies["RECOVERED"] + 1
        : 1;
    }
  });

  // Write to State
  let nextPopulation = { ...population };

  newInfections.forEach(id => {
    nextPopulation[id].status = "INFECTED";
    nextPopulation[id].infectionDate = day;
  });

  newRecoverys.forEach(id => {
    nextPopulation[id].status = "RECOVERED";
  });

  let nextEnvironment = {};
  let nextHistory = history.slice(0);
  nextHistory.push(tallies);

  return {
    population: nextPopulation,
    environment: nextEnvironment,
    history: nextHistory
  };
};

const linkRenderer = (context, links, controls) => {
  function drawLink(d) {
    context.moveTo(d.source.x, d.source.y);
    context.lineTo(d.target.x, d.target.y);
  }

  // Draw Links
  context.beginPath();
  links.forEach(d => {
    if (controls && controls.isNonEssentialWorkSuspended) {
      // inPlay = (d.priority !== "NON-ESSENTIAL-WORK" && d.priority !== "FRIENDS")
      if (d.priority !== "NON-ESSENTIAL-WORK" && d.priority !== "FRIENDS") {
        drawLink(d);
      }
    } else {
      drawLink(d);
    }
  });

  context.strokeStyle = "#aaa";
  context.stroke();
};

const nodesRenderer = (
  context,
  nodes,
  nodeStates,
  day,
  frame,
  framesPerDay,
  controls
) => {
  let animationDay = day - 1;

  nodes.forEach(d => {
    let jump = 0;

    if (animationDay === nodeStates[d.id].infectionDate) {
      // If this person was infected today
      jump =
        3 *
        Math.sin(((frame % framesPerDay) / (2 * framesPerDay)) * 2 * Math.PI);
      // Animate vertically to highlight the person
      // ... or maybe make them shake instead?
    }

    context.translate(d.x, d.y - jump);

    let p = new Path2D(
      d.age === "elder" ? elderPath : d.age === "child" ? childPath : adultPath
    );
    context.fillStyle = fillGivenStatus(nodeStates[d.id].status, d.immuno); //(nodeStates[d.id].status === "INFECTED") ? "#c00" : ((d.immuno) ? "#a80" : "black");
    context.fill(p);
    context.translate(-d.x, -d.y + jump);
  });
};

const statesList = [
  { key: "RECOVERED", label: "Recovered" },
  { key: "SUSCEPTIBLE", label: "Susceptible" },
  { key: "INFECTED", label: "Infected" }
];

export {
  simulator,
  initializeSimulationState,
  statesList,
  linkRenderer,
  nodesRenderer
};
